import _ from "lodash"
import { COLLAPSE, DATEFIELD, IMAGEGROUP, IMAGESINGLE, STRING } from "./Constants"
import ImageGroup from "../components/common/ImageGroup"
import SingleImage from "../components/common/SingleImage"
import UMCCollapse from "../components/common/UMCCollapse"
import UMCContentSplitLayout from "../components/common/UMCContentSplitLayout"
import { Divider } from "antd"
import jsonLogic from "json-logic-js"
import { getTranslated } from "./CommonUtils"
import { applyROAccess } from "./ValidationUtils"

export const convertRespArrToSingleObj = (response) => {
    let finalResp = []
    if (response?.length) {

        let list = response
        list.map((data, key) => {
            let attrObj = {}
            finalResp[key] = _.cloneDeep(data)

            data.attribute.map((attr, index) => {
                attrObj = {
                    ...attrObj,
                    [attr.id]: attr.enum ?? attr.value
                }

                if (data.attribute.length === index + 1) {
                    finalResp[key].attribute = attrObj
                }
            })
        })

        return finalResp
    } else return []
}

export const parseTableSchema = (response) => {

    if (response?.response?.length && response.response[0]?.domain?.length &&
        response.response[0].domain[0]?.boardlist?.length) {

        return response.response[0].domain[0].boardlist[0].attribute
    }

    return []
}

export const parseTableData = (response) => {

    if (response?.response?.length && response.response[0]?.domain?.length &&
        response.response[0].domain[0]?.boardlist?.length) {

        return response.response[0].domain[0].boardlist
    }

    return []
}

export const getBoardListCount = (response) => {
    if (response?.response?.length && response.response[0]?.domain?.length &&
        response.response[0].domain[0]?.boardlist?.length)
        return response.response[0].domain[0].boardlistsize

    else return 0
}

export const getDomains = (response) => {
    if (response?.response?.length && response.response[0]?.domain?.length) {

        return response.response[0].domain
    }

    return []
}

export const mergeSchemaWithData = (schema, data) => {

    if (schema?.length && data?.length) {
        return schema?.length && schema.map(item => {
            const tempData = data.find(dataItem => dataItem.id === item.id)
            if (tempData === undefined) return
            else {
                return {
                    ...tempData,
                    ...item,
                    value: tempData?.value !== undefined ? tempData.value : (item.defaultValue ?? item.value)
                }
            }
        })
    } else if (!schema?.length)
        return data
    else return schema
}

export const getFormattedEnum = (plainEnum) => {
    let formattedEnum = _.cloneDeep(plainEnum)

    formattedEnum.map(item => {
        item.value = item.value ?? item.id
        item.label = item.label ?? item.id

        return item
    })

    return formattedEnum
}

export const getTableCellData = (schema, attribute, key, rowHovered, customClassName = "") => {

    const images = require.context("../assets/images/themed-icons")

    const attrSchema = schema.find(attr => attr.id === key)

    switch (attrSchema?.widget) {
        case IMAGEGROUP: {
            let value = mergeSchemaWithData(attrSchema.enum, attribute[key])

            return <ImageGroup
                enum={value}
                hoveredRow={rowHovered}
            />
        }
        case IMAGESINGLE: {
            let value = {}
            if (attrSchema?.type === STRING) {
                value = attrSchema.enum.find(item => item.id === attribute[key])
                if (!value)
                    value = attrSchema.enum.find(item => item.id === "default") // Take the default image

                value = {
                    ...value,
                    label: attribute[key]
                }
            } else {
                value = mergeSchemaWithData(attribute[key], attrSchema.enum)
                value = value.length ? value[0] : {}
            }

            // if (value?.length)
            return <SingleImage
                imageData={value}
                hoveredRow={rowHovered}
                images={images}
                className={customClassName}
            />
            // else return <></>
        }
        case DATEFIELD: {
            return <>{new Date(attribute[key]).toLocaleString("fr", "DD/MM/YYYY hh:mm")}</>
        }
        default:
            return attribute[key]

    }
}

export const formatToLabelValue = (attribute) => {
    let tempAttr = { ...attribute }

    tempAttr.options = [{
        label: attribute.label,
        value: attribute.id
    }]

    return tempAttr
}

export const getDomainsView = (domains, otherAttrs = {}, dict = []) => {

    if (!domains?.length) return <></>

    return <>
        {
            domains.map(domain => {
                return domain.widget === COLLAPSE ?
                    <UMCCollapse
                        key={domain.id}
                        label={getTranslated(dict, domain.label)}
                        children={<UMCContentSplitLayout
                            footer={null}
                            subdomain={domain.subdomain}
                            otherAttrs={otherAttrs}
                        />}
                    /> :
                    <div key={domain.id}>
                        {domain.label && <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, domain.label)}</Divider>}
                        {<UMCContentSplitLayout
                            footer={null}
                            subdomain={domain.subdomain}
                            otherAttrs={otherAttrs}
                        />}
                    </div>
            })
        }
    </>
}

export const updateValueById = (obj, targetId, newValue, existingObject) => {

    function traverse(obj, targetId, newValue, isLink) {
        // Base case: if obj is not an object, return
        if (typeof obj !== 'object' || obj === null) return obj

        // Loop through each key in the current level
        for (let key in obj) { // Todo: Optimization required wherever looping over key
            if (obj.hasOwnProperty(key)) {
                // Check if the current object has an id matching the targetId
                if (key === 'id' && obj[key] === targetId) {
                    const existingValue = existingObject ? (existingObject.value || "") : undefined;
                    const isModified = existingValue !== newValue; // Compare values safely

                    if (isModified) {
                        obj.isModified = true;  // Set isModified only when there's a change
                    } else {
                        delete obj.isModified; // Remove it if no changes
                    }
                    obj.value = newValue  // Update the value (or any key you want to change)
                    //console.log('existing Object : '+JSON.stringify(existingObject))
                    isLink = obj.isLink

                    return { obj, isLink } // Return true when the target is found and updated
                }

                // Recursively traverse nested objects and arrays
                if (typeof obj[key] === 'object') {
                    const result = traverse(obj[key], targetId, newValue, isLink)
                    if (result) return { obj, isLink: result.isLink } // Exit when found and updated
                }
            }
        }
        return false // Return false if not found
    }

    const updatedObj = traverse(obj, targetId, newValue, false)
    return updatedObj
}

/* Find the object using targetId, apply the callback to it if found, and update the object with the callback's return value */
export const updateObjectById = (obj, targetId, callback) => {
    if (typeof obj !== 'object' || obj === null) return obj // Base case

    // Clone the object to avoid modifying original data
    let clonedObj = JSON.parse(JSON.stringify(obj))
    let isUpdated = false // Flag to stop recursion once found

    function traverseAndUpdate(parent, key, currentObj) {
        if (!currentObj || typeof currentObj !== 'object' || isUpdated) return // Stop recursion if already found

        // Check if the current object has the target ID
        if (currentObj.id === targetId) {
            parent[key] = { ...callback(currentObj) } // Apply callback & update the parent
            isUpdated = true // Mark as updated to stop further recursion
            return
        }

        // Recursively traverse nested objects and arrays
        for (let childKey in currentObj) {
            if (typeof currentObj[childKey] === 'object') {
                traverseAndUpdate(currentObj, childKey, currentObj[childKey])
                if (isUpdated) return // Exit early once found
            }
        }
    }

    traverseAndUpdate(clonedObj, targetId, clonedObj)

    return clonedObj
}

/* dest - schema, src - data,  keyToMerge - object key to perform deep merge */
export const deepMergeObjects = (dest, src, keyToMerge = "attribute") => {
    let schema = _.cloneDeep(dest), data = _.cloneDeep(src), clonedData = _.cloneDeep(data);

    function traverse(schema, data) {

        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === keyToMerge) { // Merge `attribute` arrays based on their `id`
                    schema[key] = _.map(schema[key], function (item) {

                        const foundItem = _.find(data[key], { 'id': item.id })
                        item = foundItem ? _.merge(item, foundItem) : item

                        if (foundItem) {
                            if (foundItem.value === "") {
                                item.value = item.conditionalDefault ? replaceLinkPhAndApplyJLogic(item.conditionalDefault, clonedData, false) : item.defaultValue || ""
                            } else {
                                item.value = foundItem.value
                            }

                            if(item.mandatoryLink) { //Setting mandatory attribute dynamically based on mandatorylink
                                item.mandatory = replaceLinkPhAndApplyJLogic(item.mandatoryLink, clonedData, false)
                            }

                            if (item.enum?.length || foundItem.enum?.length) {
                                item.enum = (item.enum?.length && foundItem.enum?.length) ? _.merge(item.enum, foundItem.enum) : (item.enum || foundItem.enum)
                                item.enum = validateConditionalEnum(item.enum, clonedData)
                                // return _.merge(item, _.find(data[key], { 'id': item.id }))
                            }

                            if(item.buttonaddon?.link) 
                                item.buttonaddon.visible = replaceLinkPhAndApplyJLogic(item.buttonaddon.link, clonedData, false)

                            return item
                        } else
                            return item
                    })
                } else if (data[key] instanceof Object) { // Recursively traverse nested objects
                    if (schema[key] === undefined) {
                        schema[key] = Array.isArray(data[key]) ? [] : {}
                    }
                    schema[key] = traverse(schema[key], data[key])
                } else { // For primitive types, directly assign the value
                    schema[key] = data[key]
                }
            }
        }

        return schema
    }

    traverse(schema, data)

    return schema
}


export const parseDomainToGUIModal = (domains) => {
    return {
        // umcObject: {
        //     scope: {
        domain: domains
        //     }
        // }
    }
}

export const validateLinks = (data) => {
    const attributesWithIsLink = getAllAttrWithIsLink(data)
    const updatedData = validateAllLinkPlaceholders(data, attributesWithIsLink)

    return updatedData
}

export const getAllAttrWithIsLink = (obj) => {
    const result = []

    // Recursive function to traverse object
    function traverse(current) {
        if (Array.isArray(current)) {
            current.forEach(traverse)
        } else if (current && typeof current === "object") {

            if (current.attribute && Array.isArray(current.attribute)) {
                result.push(...current.attribute.filter(attr => attr.hasOwnProperty("isLink")))
            } else {
                for (let key in current) {
                    if (typeof key === "object") {
                        current[key].forEach(traverse)
                    }
                }
            }
            Object.values(current).forEach(traverse)
        }
    }

    traverse(obj)
    return result
}

export const validateAllLinkPlaceholders = (obj, attributesWithIsLink) => {
    function traverse(current) {
        if (Array.isArray(current)) {
            current.forEach(traverse)
        } else if (current && typeof current === "object") {

            if (current.attribute && Array.isArray(current.attribute)) {
                current.attribute.forEach(attr => {
                    if (attr.hasOwnProperty("link")) {
                        const status = replaceLinkPhAndApplyJLogic(attr.link, attributesWithIsLink)
                        // const status = jsonLogic.apply(linkWithData, null)
                        attr.visible = status // Add the 'visible' property [true / false]
                    }

                    if(attr.hasOwnProperty("mandatoryLink")) { //Setting mandatory attribute dynamically based on mandatorylink
                        attr.mandatory = replaceLinkPhAndApplyJLogic(attr.mandatoryLink, attributesWithIsLink)
                    }
                })
            } else {
                for (let key in current) {
                    if (typeof key === "object") {
                        traverse(current[key])
                    }
                }
            }
            Object.values(current).forEach(traverse)
        }
    }

    traverse(obj)

    return obj // Return the modified object
}

// Function to replace link placeholders with values and apply JSON logic, which'll return JSON validated value [true/false/<String>]
export const replaceLinkPhAndApplyJLogic = (jsonLogicString, attrValues, isLinksList = true) => { // If isLinksList false, manually parse & find the value, else get from the list provided 
    const parsedVar = JSON.parse(jsonLogicString, (key, value) => {
        if (typeof value === 'string' && value.startsWith('#') && value.endsWith('#')) {
            const placeholder = value.slice(1, -1) // Remove # symbols
            const phValue = isLinksList ? attrValues.find(attr => attr.id === placeholder) : findInObjectById(attrValues, placeholder)

            return phValue?.value || ""
        }
        return value // Otherwise return as-is
    })

    return jsonLogic.apply(parsedVar, null)
}

// Helper function to find value by id in the updates object
export function findInObjectById(obj, keyToFind) {
    let foundValue = null // To store the result when found

    function traverse(object) {
        for (let key in object) {
            if (object.hasOwnProperty(key)) {
                // Check if the key and value match
                if (object[key]?.id === keyToFind) {
                    foundValue = object[key]
                    return true // Break the recursion
                }

                // If the value is an object, traverse it recursively
                if (typeof object[key] === 'object' && object[key] !== null) {
                    if (traverse(object[key])) {
                        return true // Stop further recursion
                    }
                }
            }
        }
        return false // Continue recursion if no match
    }

    traverse(obj) // Start traversing the object

    return foundValue // Return the found value or null
}

// Based on value of `updates` object, source(base) object get updated
export function updateObjByObj(source, updates) {

    // Recursive function to traverse and update attributes in source
    function traverseAndUpdate(obj) {
        if (Array.isArray(obj)) {
            obj.forEach(traverseAndUpdate) // Handle arrays
        } else if (obj && typeof obj === "object") {
            if (obj.attribute) {
                obj.attribute.forEach(attr => {
                    const newValue = findInObjectById(updates, attr.id)
                    if (newValue !== null) {
                        attr.value = newValue.value // Take value from data 
                        attr.enum = (attr.enum?.length && newValue.enum?.length) ? mergeObjects(newValue.enum, attr.enum) : (newValue.enum || attr.enum)
                    }

                    if (attr.value === undefined) {
                        let updatedValue = attr.defaultValue // Take defaultValue from schema if no value set by data
                        if (attr.conditionalDefault) { // If conditionalDefault set, validate it and update the data
                            updatedValue = replaceLinkPhAndApplyJLogic(attr.conditionalDefault, updates, false)
                        }
                        attr.value = updatedValue || ""
                    }

                    if(attr.mandatoryLink){ //Setting mandatory attribute dynamically based on mandatorylink
                        attr.mandatory = replaceLinkPhAndApplyJLogic(attr.mandatoryLink, updates, false)
                    }

                    if (attr.enum?.length)
                        attr.enum = attr.enum?.length && validateConditionalEnum(attr.enum, source)

                    if (attr.buttonaddon?.link)
                        attr.buttonaddon.visible = replaceLinkPhAndApplyJLogic(attr.buttonaddon.link, updates, false)
                })
            }
            // Recursively process subdomains if present
            if (obj.subdomain) {
                traverseAndUpdate(obj.subdomain)
            }
        }
    }

    let tempSource = _.cloneDeep(source)
    // Start traversal
    traverseAndUpdate(tempSource)

    return tempSource // Return the updated source object
}

export const mergeObjects = (src, dest) => {
    dest.map(item => {
        const destitem = findInObjectById(src, (item.id || item.value))
        if (destitem) {
            item = _.merge(item, destitem)
        }
        return item
    })

    return dest
}

/**
 * 
 * @param {Array} enumList Enum list array 
 * @param {Object} dataObj Data object with all attribute value
 * @param {Boolean} isLinksList If isLinksList false, manually do hierarchical parsing & find the value, else get from the list provided 
 * @returns conditionalEnum validated enum list
 */
const validateConditionalEnum = (enumList, dataObj, isLinksList = false) => {
    const list = enumList?.filter(enumItem =>
        (!enumItem.conditionalEnum || (enumItem.conditionalEnum && replaceLinkPhAndApplyJLogic(enumItem.conditionalEnum, dataObj, isLinksList))) 
    )

    return list
}

/**
 * Function to decide the accessibility of button-addon. 
 * Priority order => disabled - true; ReadOnly - true; visible param set based on link validation; finally return false   
 * @param {*} attribute 
 * @returns true | false
 */
export const validateButtonAddon = (attribute) => {
    const isReadOnly = applyROAccess(attribute.buttonaddon.access, attribute.actionMode)
    
    if (attribute.buttonaddon.disabled || isReadOnly)
        return true
    else if ((attribute.buttonaddon.link)) 
        return attribute.buttonaddon.visible ? false : true
    else 
        return false
}

/**
 * Check if any of the param isModified set with true
 * @param {*} obj 
 * @returns true | false
 */
export const checkIfAnyModified = (obj) => {
    if (!obj || typeof obj !== 'object') return false

    if (Array.isArray(obj)) {
        return obj.some(checkIfAnyModified)
    }
    if (obj.isModified || obj.action) return true
    
    return Object.values(obj).some(checkIfAnyModified)
}